<template>
	<div class="cm-list-item">
		<div class="card">
			<div class="row no-gutters">
				<div class="item-img col col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<router-link
						:to="{ name: 'Details', params: { id: car._id } }"
						:car-data="car"
						class="item-img-box"
					>
						<img
							:src="car.image"
							title="First vehicle image"
							class="item-img img-fluid"
						/>
						<img
							:src="car.imageWatermark"
							title="First vehicle image"
							class="img-banner item-img img-fluid"
						/>

						<div class="cm-img-overlay d-flex justify-content-center">
							<i class="mdi mdi-magnify align-self-center"></i>
						</div>
					</router-link>
					<div class="cm-loader loader-item-img"></div>
				</div>
				<div
					class="item-body col-item-body col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
				>
					<div class="row no-gutters h-100">
						<div class="item-content col-9 col-md-9 col-xl-9 col-lg-9">
							<div class="cm-list-item-body ps-xl-2 ps-lg-2 ps-md-2">
								<router-link
									:to="{ name: 'Details', params: { id: car._id } }"
									:car-data="car"
									class="h5 item-list-title item-title d-inline-block text-dark"
								>
									{{ carTitle }}
								</router-link>
								<div class="cm-list-item-subtitle item-subtitle">
									<div class="d-block">
										<span
											v-if="car.ad.usageType"
											class="badge badge-light font-12 rounded font-w-500"
											>{{ refData[car.ad.usageType] }}</span
										>
										<span
											v-else
											class="badge badge-light font-12 rounded font-w-500"
											>{{ refData[car.ad.condition] }}</span
										>
										<span
											v-if="isAvailable"
											class="ms-1 badge badge-red font-12 rounded font-w-500"
											>Sofort verfügbar</span
										>
									</div>
								</div>
								<list-item-features :car="car" :ref-data="refData" />
							</div>
						</div>
						<div class="item-pricing col-3 col-md-3 col-xl-3 col-lg-3">
							<list-item-pricing :car="car"></list-item-pricing>
						</div>

						<div
							class="item-body-bottom ms-auto col-12 ps-xl-2 ps-lg-2 ps-md-2"
						>
							<div class="w-100 subtext">
								<list-item-subtext :car="car" />
							</div>
						</div>
						<div class="col-12 align-self-end">
							<div class="item-footer align-self-end bg-lighter w-100">
								<div class="row g-0 align-items-center">
									<div
										class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 text-center text-sm-start"
									></div>
									<div
										class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 p-1"
									>
										<div class="row g-2 g-md-2">
											<div class="col-12 col-sm-6 col-md-6 col-lg-6 text-end">
												<button
													role="button"
													class="btn btn-outline-primary btn-block"
													v-if="!isBookmarked"
													@click="this.removeCarFromBookmarks(car._id)"
												>
													<i class="mdi mdi-star"></i> Gemerkt
												</button>
												<button
													v-else
													role="button"
													class="btn add-car-to-bookmark btn-bookmark-car btn-block btn-white"
													@click="this.addCarToBookmarks(car)"
												>
													<i class="mdi mdi-star-outline"></i> Merken
												</button>
											</div>
											<div class="col-12 col-sm-6 col-md-6 col-lg-6">
												<router-link
													:to="{ name: 'Details', params: { id: car._id } }"
													:car-data="car"
													class="btn btn-dark btn-block"
												>
													Details <i class="mdi mdi-chevron-right"></i>
												</router-link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ListItemPricing from '@/components/list/ListItemPricing'
import ListItemFeatures from '@/components/list/ListItemFeatures'
import store from '@/store'
import DarmasApiService from '@/services/DarmasApiService'
import ListItemSubtext from '@/components/list/ListItemSubtext'

export default {
	name: 'ListItem',
	components: {
		ListItemPricing,
		ListItemFeatures,
		ListItemSubtext,
	},
	props: {
		car: Object,
		refData: Object,
		loading: Boolean,
	},
	data() {
		return {
			popover: 'hidden',
		}
	},
	computed: {
		carTitle() {
			return this.refData[this.car.ad.make] + ' ' + this.car.ad.modelDescription
		},
		isBookmarked() {
			return store.state.user.bookmarks.cars[this.car._id] === undefined
		},
		currentDate() {
			return new Date().toISOString().slice(0, 10)
		},
		isAvailable() {
			let ad = this.car.ad
			let isAvailable = false

			if (!ad.deliveryPeriod && !ad.deliveryDate) {
				isAvailable = true
			} else if (!ad.deliveryPeriod && ad.deliveryDate) {
				const adDate = new Date(ad.deliveryDate)
				const currentDate = new Date(this.currentDate)

				adDate.setHours(0)
				adDate.setMinutes(0)

				// FIX: one day delay for `sofort verfügbar` patch
				// TODO Filter also needs to be fixed
				// isAvailable = ad.deliveryDate <= this.currentDate
				isAvailable = adDate <= currentDate
			}

			return isAvailable
		},
		carPrice() {
			const priceFormat = +this.car.ad.price.consumerPriceGross
			return priceFormat.toFixed(0) + ' €'
		},
		carFirstRegistration() {
			return this.car.ad.firstRegistration
		},
	},
	methods: {},
	created() {
		/*let date = new Date().toISOString().slice(0, 10)
		console.log(date)*/
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.badge-red {
	border: 1px solid $primary;
	background-color: $primary;
}
</style>
